
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/top/top100_authors",
      function () {
        return require("private-next-pages/top/top100_authors.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/top/top100_authors"])
      });
    }
  